import { CompanyRiskScoreView } from '../view/CompanyRiskScoreView';
import { templateCompanyRiskScore } from '../view/template';
import { BaseWidgetController } from '../../widget/BaseWidgetController';
import { GetCompanyRiskScoreResponse } from '@nirvana/shared/dtos/types/widgets/common';
import { CompanyRiskScoreWebComponent } from '../component/CompanyRiskScoreWebComponent';

export class CompanyRiskScoreController extends BaseWidgetController<GetCompanyRiskScoreResponse> {
  public component: CompanyRiskScoreWebComponent;
  public view: CompanyRiskScoreView;
  public viewConstructor: typeof CompanyRiskScoreView;

  constructor(component: CompanyRiskScoreWebComponent) {
    super(component);
    this.initialWidgetSetup({
      viewConstructor: CompanyRiskScoreView,
      viewTemplate: templateCompanyRiskScore,
      dataFetchMethod: this.component.dependencies.api.clients.Widgets.getCompanyRiskScore,
    });
  }
}
